import cssVars from "css-vars-ponyfill";

export const vhUpdate = () => {
  const doc = document.documentElement;
  const vh = `${window.innerHeight * 0.01}px`;

  doc.style.setProperty("--vh", vh);

  // For IE 11
  cssVars({
    variables: {
      vh
    }
  });
};
